module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid59_980x863.4cd1d5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid59_980x863.jpg
// module id = 2uXj
// module chunks = 0